import React from 'react';
import { useIntl } from 'react-intl';
import * as consts from '../../consts/consts';
import Page from '../Layout/Pages/Page';
import OneOnOnesDirectory from './OneOnOnesDirectory';

const OneOnOnesDirectoryPage: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Page title={consts.TEAM_ONE_ON_ONES(formatMessage).name}>
      <OneOnOnesDirectory />
    </Page>
  );
};

export default React.memo(OneOnOnesDirectoryPage);
